import { BoxProps, TextProps as TextStyle } from '@jfs/ui-new'
import { Colors } from '../../util/util'

const styles = (viewportWidth: number) => {
  const isMobile = viewportWidth < 620

  return {
    otpButtonContainer: {
      alignItems: 'center',
      marginTop: 20,
      // marginHorizontal: 64,
    } as BoxProps,

    otpMainContainer: {
      // height: isMobile ? 300 : undefined,
      alignSelf: 'center',
      paddingVertical: 20,
      // paddingHorizontal: 20,
      margin: 0,
      width: '86%',
      maxWidth: isMobile ? '100%' : 400,
    } as BoxProps,

    backImage: {
      width: 32,
      height: 32,
    } as BoxProps,

    backTouchableStyle: {
      height: 32,
      // width: 32,
      margin: 0,
      padding: 0,
      backgroundColor: 'WHITE',
      alignSelf: 'flex-start',
      underlayColor: 'WHITE',
    } as BoxProps,

    enterOtpStyle: {
      fontSize: 20,
      fontWeight: 'bold',
      color: Colors.BLACK_21,
    } as TextStyle,

    userInfoContainer: {
      pt: 12,
      flexDirection: 'row',
      flexWrap: 'wrap',
    } as BoxProps,

    userInfoStyle: {
      fontSize: 12,
      fontWeight: '300',
      marginEnd: 3,
      color: Colors.LIGHT_BLACK,
    } as TextStyle,

    mobileNumberStyle: {
      fontSize: 12,
      fontWeight: '500',
      marginEnd: 3,
      color: Colors.BLACK_21,
    } as TextStyle,

    editStyle: {
      fontSize: 12,
      fontWeight: '400',
      color: 'BLUE',
    } as TextStyle,

    formContainer: {
      height: 225,
      zIndex: 5,
    } as BoxProps,
    tryagainText: {
      fontSize: 12,
      fontWeight: '400',
      color: Colors.ORANGE_C,
      textAlign: 'center',
      margin: 0,
      marginBottom: 40,
    } as TextStyle,
    errorStyle: { alignItems: 'center', marginTop: 8 } as BoxProps,
    mainContainer: {
      height: '100%',
      width: '100%',
      flex: 1,
      overflow: 'auto',
      backgroundColor: Colors.JIO_PRIMARY,
    } as BoxProps,
    cardContainer: {
      // flexDirection: 'column',
      width: '100%',
      // flex: 1,
      paddingTop: isMobile ? 32 : 60,
    } as BoxProps,
    container: {
      flex: 1,
      width: '100%',
      alignSelf: 'center',
    } as BoxProps,
    card: {
      backgroundColor: Colors.WHITE,
      shadowColor: Colors.HALF_WHITE,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.4,
      mt: 35,
      shadowRadius: 4,
      zIndex: 4,
      minWidth: isMobile ? undefined : 308,
      paddingHorizontal: 15,
      alignSelf: 'center',
      borderRadius: 16,
      paddingVertical: 20,
    } as BoxProps,
  }
}

export { styles }
